import Style from 'ol/style/Style';
import Circle from 'ol/style/Circle';
import Stroke from 'ol/style/Stroke';
import Fill from 'ol/style/Fill';
import VectorSource from 'ol/source/Vector';
import VectorLayer from 'ol/layer/Vector';
import GeoJSON from 'ol/format/GeoJSON';

export const EVENTS_14 = 'EVENTS_14';
export const layer14 = new VectorLayer({
    renderMode: 'image',
    style: new Style({
      stroke: new Stroke({
        color: 'rgba(0, 188, 212, 0.5)',
        width: 6,
      }),
      fill: new Fill({
        color: 'rgba(0, 0, 0, 0.0)',
      }),
      image: new Circle({
        stroke: new Stroke({
            color: '#a01934',
            width: 6
        }),
        radius: 8,
        fill: new Fill({
            color: '#a01934'
        }),
       })
    }),
    source: new VectorSource({
      format: new GeoJSON(),
      url: '/api?action=layer&layer=Notikumi_14jun.geojson'
    //  features: (new ol.format.GeoJSON()).readFeatures({type: "FeatureCollection", crs:geojson.crs, features:geojson.features})
    })
});

export const EVENTS_25 = 'EVENTS_25';
export const layer25 = new VectorLayer({
  renderMode: 'image',
  style: new Style({
    stroke: new Stroke({
      color: 'rgba(0, 188, 212, 0.5)',
      width: 6,
    }),
    fill: new Fill({
      color: 'rgba(0, 0, 0, 0.0)',
    }),
    image: new Circle({
      stroke: new Stroke({
          color: '#a01934',
          width: 6
      }),
      radius: 8,
      fill: new Fill({
          color: '#a01934'
      }),
     })
  }),
  source: new VectorSource({
    format: new GeoJSON(),
    url: '/api?action=layer&layer=Notikumi_25mar.geojson'
  })
});



// WEBPACK FOOTER //
// ./C:/Users/viesis/Desktop/deportacijas/src/memorialEvents/assets.js